<template>
  <div id="camera">
      <!-- Uploading image -->
      <div class='container'>
            <transition name="fade">
                <div v-if="addingFile" class="loading">
                    <p>Uploading Image...</p>
                </div>
            </transition>
        </div>

      <b-container>
        <!-- Video stream -->
        <div >
            <video ref="video" id="video" width="75%" height="75%" autoplay/>
        </div>
        <canvas style="text-align:center"  v-if="showCamera" ref="canvas" id="canvas" width="75%" height="75%"/>

        <!-- Button to snap image -->
        <div v-if="showCamera" style="margin-top:10px; margin-bottom:10px">
            <b-button id="snap" variant="primary" size='lg' @click="capture()"><font-awesome-icon icon="camera" /> Snap Photo</b-button>
            <b-button style="margin-left:10px" id="cancelcapture" variant="danger" size='lg' @click="cancelImageCapture()">Cancel</b-button>
        </div>

        <!-- Show captured image -->
        <div v-if="!showCamera">
            <h4 v-if="!showCamera">Captured Image</h4>
            <img v-if="!showCamera" style="cursor: pointer;" :src="capturedImage" width="75%" height="75%" fluid alt="Logo image" >
            <div style="margin-top:10px">
                <b-button @click="useImage()">Use Image</b-button>
                <b-button style="margin-left:10px" @click="reTake()"><font-awesome-icon icon="camera" /> Retake</b-button>
            </div>
        </div>
      </b-container>
  </div>
</template>




<script>
import { mapState } from 'vuex'


export default {
    name: 'Camera',
    props:['imageid'], //To send back to the parent
    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'createdItemForSale','cameraImageId', 'capturedImages'])
    },

  data() {
    return {
        showCamera:true,
        video: {},
        canvas: {},
        captures: [],
        mediaStream:null,
        capturedImage:'',
        theSaleItem:{},
        addingFile:false,
        cloudinary: {
            logoFullPreset:'forsalefullimage',
            logoThumbPreset:'forsalethumbnailimage',
            apiKey: '629997215451183',
            cloudName: 'lo4xxr5lr',
            uploadURL:'https://api.cloudinary.com/v1_1/lo4xxr5lr/upload'
        }, 
    }
  },

  methods: {
      //Start the video
      startVideo(){
        //Show camera
        var x = document.getElementById("video");
        if (x.style.display === "none") {
            x.style.display = "block";
        } 

        this.video = this.$refs.video;
        if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            console.log("Got Stream")
            navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
                this.mediaStream = stream
                this.video.srcObject = stream;
                video.play();
                video.onplay = function () {
                    this.video=video
                };
                this.video.play();
            });
        }

      },

      //Take picture
    capture() {
        console.log("Capturing")
        this.canvas = this.$refs.canvas;
        var context = this.canvas.getContext("2d").drawImage(this.video, 0, 0, 640, 480);
        this.captures.push(canvas.toDataURL("image/webp"));

        const mediaStreamTrack = this.mediaStream.getVideoTracks()[0]
            const imageCapture = new window.ImageCapture(mediaStreamTrack)
            return imageCapture.takePhoto().then(blob => {
                console.log(blob)
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(blob);
                this.capturedImage=imageUrl
                console.log("Image URL = " + imageUrl)
                this.showCamera=false
                //Hide camera
                var x = document.getElementById("video");
                x.style.display = "none";
        })
    },   

        //Retake image
        reTake(){
            this.showCamera=true
            this.startVideo()
        },

        //Use image
        useImage(){

            //Store image
            var localCapturedImages = this.capturedImages
            localCapturedImages[this.cameraImageId] = this.cameraImageId
            localCapturedImages[this.cameraImageId+'url'] = this.capturedImage
            this.$store.commit('setCapturedImages',localCapturedImages)

            //Hide camera
            var x = document.getElementById("video");
            x.style.display = "none";
            console.log("Using: " + this.capturedImage)
            this.$store.commit('setCameraImageUrl',this.capturedImage)

            //Go back
            this.$router.go(-1) 
        },

        //Cancel image capture
        cancelImageCapture(){
            this.$store.commit('setCameraImageUrl','')
            this.$store.commit('setCameraImageId','')
            this.$router.go(-1) 
        },
    },

    mounted() {
        //Set item for sale
        this.theSaleItem = this.createdItemForSale
        this.startVideo()
        
    },
    destroyed () {
        const tracks = this.mediaStream.getTracks()
        tracks.map(track => track.stop())
  }
    
}
</script>

<style scoped>
    #camera {
        text-align: center;
        color: #2c3e50;
    }
    #video {
        background-color: #000000;
    }
    #canvas {
        display: none;
    }
    li {
        display: inline;
        padding: 5px;
    }
</style>